import { createContext, Dispatch, useContext } from 'react'

import { Action, State } from '../../CanaryPageBuilder/types'
import { useCustomizer } from './useCustomizer'

export interface ThemePreviewContext {
  state: State
  dispatch: Dispatch<Action>
}

const ThemePreviewContext = createContext<ThemePreviewContext>(undefined)

export const ThemePreviewProvider = ({ children }) => {
  const { state, dispatch } = useCustomizer()

  return (
    <ThemePreviewContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </ThemePreviewContext.Provider>
  )
}

export const useThemePreviewContext = () => useContext(ThemePreviewContext)
